import { CORE_SPREAD_DEFINITIONS } from '../definitions/core.js';
import { DECISION_SPREAD_DEFINITIONS } from '../definitions/decision.js';
import { KABBALISTIC_SPREAD_DEFINITIONS } from '../definitions/kabbalistic.js';
import { LILITH_SPREAD_DEFINITIONS } from '../definitions/lilith.js';
import { RELATIONAL_SPREAD_DEFINITIONS } from '../definitions/relational.js';
import { SHADOW_SPREAD_DEFINITIONS } from '../definitions/shadow.js';
import { SPIRITUAL_SPREAD_DEFINITIONS } from '../definitions/spiritual.js';
import { TEMPORAL_SPREAD_DEFINITIONS } from '../definitions/temporal.js';
const dedupeBySlug = (definitions) => {
    const registry = new Map();
    for (const definition of definitions) {
        registry.set(definition.spread.slug, definition);
    }
    return Array.from(registry.values());
};
export const ALL_SPREAD_DEFINITIONS = dedupeBySlug([
    ...CORE_SPREAD_DEFINITIONS,
    ...RELATIONAL_SPREAD_DEFINITIONS,
    ...DECISION_SPREAD_DEFINITIONS,
    ...TEMPORAL_SPREAD_DEFINITIONS,
    ...SHADOW_SPREAD_DEFINITIONS,
    ...SPIRITUAL_SPREAD_DEFINITIONS,
    ...LILITH_SPREAD_DEFINITIONS,
    ...KABBALISTIC_SPREAD_DEFINITIONS,
]);
export const ALL_SPREADS = ALL_SPREAD_DEFINITIONS.map((definition) => definition.spread);
//# sourceMappingURL=all-spreads.js.map